import React, { Component } from "react";
import { NavLink, useLocation, useHistory } from "react-router-dom";
import "./index.css";
import AdvisorContext from "../context/context";
import { Grid, Checkbox, TextField, Button, Typography, IconButton } from '@material-ui/core';
import Modal from "react-modal";
import { Tabs, Tab } from '@mui/material';
import { advisorSearch } from "../api.js";
import QuickLinkList from "./components/quickLinkList";
import ReactTable from "react-table";
import AdvancedSearch from "../../common/search";


const processData = (cases) => {
    const gradeCounts = {};

    cases.forEach(caseItem => {
        if (caseItem.studentContactInfo.contacted) {
            const grade = caseItem.studentProfile.currentGrade;
            gradeCounts[grade] = (gradeCounts[grade] || 0) + 1;
        }
    });

    return Object.entries(gradeCounts).map(([grade, count]) => ({ grade, count }));
};


class AdvisorsDashboard extends Component {
    static contextType = AdvisorContext;
    constructor(props) {
        super(props);

        this.state = {
            showSearch: false,
            searchTab: 0,
            searchStudents: [],
            searchPriParents: [],
            searchSecParents: [],
            studVis: "tabHidden",
            parVis: "tabHidden",
            searchVal: ""

        };
    }

    closeSearch = () => {
        this.setState({
            showSearch: false,
            searchTab: 0,
            searchStudents: [],
            searchPriParents: [],
            searchSecParents: [],
            studVis: "tabHidden",
            parVis: "tabHidden",
            searchVal: ""
            });
    }

    componentDidMount() {
        if (this.context.recipients.length > 0) {
            this.setState({ recCount: this.context.recipients.length });
        }

    }
    componentDidUpdate(prevProps, prevState) {

        if (this.context.recipients.length != this.state.recCount) {
            this.setState({ recCount: this.context.recipients.length });
        }

    }
    runSearch = async () => {
        const res = await advisorSearch({ text: this.state.searchVal });
        
        this.setState({ searchStudents: res.data.result.students, searchPriParents: res.data.result.parents });
    }

    updateSearch = async (event) => {
       


        this.setState({ searchVal: event.target.value.toLowerCase() });

       
    }


    setTab = (event, newVal) => {
        let studVis = "tabHidden";
        let parVis = "tabHidden";
        
        switch (newVal) {
            case 0:
                studVis = "tabVisible";
                parVis = "tabHidden";
                
                break;
            case 1:
                studVis = "tabHidden";
                parVis = "tabVisible";
                
                break;
            
            default:
                studVis = "tabVisible";
                parVis = "tabHidden";
                break;


        }

        this.setState({ searchTab: newVal, parVis: parVis, studVis: studVis });
    }

    getQuickLinks = () => {
        const { myBasics, myCases, loaded } = this.context;
        const hasCases = myCases.length > 0;
        // An advisor with an empty caseload still has a known count of 0, so fall back to
        // `loaded` rather than treating "no cases" as "still loading".
        const countKnown = loaded || hasCases;

        // Destinations from the Enhancement #7 wireframe get appended to this list.
        return [
            {
                id: "casesQuickLink",
                label: "Caseload",
                icon: "users",
                count: countKnown ? myCases.length : null,
                loading: !countKnown,
                onClick: () => this.props.gotoLocation("cases")
            },
            {
                id: "studentSearchQuickLink",
                label: "Student Search",
                icon: "search",
                onClick: () => this.setState({ showSearch: true, searchTab: 0, studVis: "tabVisible" })
            },
            {
                id: "guardianSearchQuickLink",
                label: "Guardian Search",
                icon: "search",
                onClick: () => this.setState({ showSearch: true, searchTab: 1, parVis: "tabVisible" })
            },
            {
                id: "aprReportQuickLink",
                label: "APR Report",
                icon: "file-text",
                onClick: () => this.props.gotoLocation("aprreport")
            },
            {
                id: "myMilestonesQuickLink",
                label: "My Milestones",
                icon: "flag-checkered",
                onClick: () => this.props.openAdvisorMilestones(this.context.myBasics.userProfile.userId)
            },
            {
                id: "milestonesOverviewQuickLink",
                label: "Milestones Overview",
                icon: "bar-chart",
                visible: !!(myBasics.isAdmin || myBasics.isStaff || myBasics.isSupervisor),
                onClick: () => this.props.gotoLocation("milestones")
            },
            {
                id: "adminLogQuickLink",
                label: "Admin Log",
                icon: "book",
                visible: !!(myBasics.isAdmin || myBasics.isStaff),
                onClick: () => this.props.gotoLocation("adminLog")
            },
            {
                id: "directorLogQuickLink",
                label: "Director Log",
                icon: "book",
                visible: !!(myBasics.isSupervisor && !myBasics.isAdmin && !myBasics.isStaff && hasCases),
                onClick: () => this.props.gotoLocation("directorlog")
            },
            {
                id: "objectivesQuickLink",
                label: "Objectives",
                icon: "bullseye",
                // Supervisors get the team table too: GetAdvisorList already scopes it to their
                // direct reports, the same way Milestones Overview is shared (OWL-2334).
                visible: !!(myBasics.isAdmin || myBasics.isSupervisor),
                onClick: () => this.props.gotoLocation("objectives")
            },
            {
                id: "myObjectivesQuickLink",
                label: "My Objectives",
                icon: "bullseye",
                visible: !myBasics.isAdmin && !myBasics.isStaff,
                onClick: () => this.props.openAdvisorObjectives(this.context.myBasics.userProfile.userId)
            }
        ];
    }

    // One link per direct report, straight to that advisor's caseload. Supervisors reach the
    // same views today by drilling through the Objectives Met graph (OWL-2315).
    getTeamLinks = () => {
        const { myBasics, myCases, loaded } = this.context;
        // The server hands admins and staff every advisor in the system as a subordinate, so
        // the team panel is limited to supervisors the same way Director Log is.
        if (!myBasics.isSupervisor || myBasics.isAdmin || myBasics.isStaff) {
            return [];
        }

        const subordinates = (myBasics.subordinates || []).filter((sub) => sub.userProfile != null);

        return subordinates
            .slice()
            .sort((a, b) => {
                const last = (a.userProfile.lastName || "").localeCompare(b.userProfile.lastName || "");
                return last !== 0 ? last : (a.userProfile.firstName || "").localeCompare(b.userProfile.firstName || "");
            })
            .map((sub) => {
                // allAdvisors is matched on userId because the server sends it as UserProfile records.
                // It resolves through the same rules as the advisor's own caseload, so this count equals
                // what that advisor sees when they log in, and equals the drilldown this card opens.
                const advisorUserId = sub.userProfile.userId;
                const assigned = loaded
                    ? myCases.filter((myCase) =>
                        Array.isArray(myCase.allAdvisors) &&
                        myCase.allAdvisors.some((advisor) => advisor.userId == advisorUserId)).length
                    : null;

                return {
                    id: `teamCaseloadQuickLink-${advisorUserId}`,
                    label: `${sub.userProfile.firstName} ${sub.userProfile.lastName}`,
                    icon: "user",
                    count: assigned,
                    loading: !loaded,
                    onClick: () => this.props.openCaseload(advisorUserId)
                };
            });
    }

    // myBasics starts out as [], so role flags read as undefined until the first batch of
    // context requests resolves. Waiting for it keeps role-restricted links from briefly
    // rendering for users who should not have them.
    roleKnown = () => {
        const { myBasics } = this.context;
        return myBasics != null && myBasics.userProfile != null;
    }

    render() {
        const quickLinks = this.getQuickLinks();
        const teamLinks = this.getTeamLinks();

        return (
            <div className="AdvisorLandingContainer">
                <div className="AdvisorLandingHeader">
                   
                                <span className="AdvisorHeaderMessage">Welcome {this.context.myInfo.firstName} {this.context.myInfo.lastName}</span><br /><br />
                    <br /><br />
                    <div className="caseloadHeaderStatus">{this.context.statusMessage} &nbsp;</div>
                </div>
                {this.roleKnown()
                    ? <>
                        <QuickLinkList links={quickLinks} title="Quick Links" />
                        {teamLinks.length > 0 ? <QuickLinkList links={teamLinks} title="My Team's Caseloads" /> : null}
                    </>
                    : <div className="quickLinkPanel"><div className="quickLinkPanelHeader AdvisorHeaderMessage">Loading your dashboard...</div></div>}
                <AdvancedSearch isOpen={this.state.showSearch} resultClick={this.props.openSearchProfile} closeSearch={this.closeSearch} label="Search" searchTab={this.state.searchTab } />
               

            </div >

        );
    };
        
    

}


export default AdvisorsDashboard;
